import React from 'react';
import {
  ProgressTrackerWrapper,
} from './styles/ProgressTracker.styles';
import ProgressMeter from './ProgressMeter';

type ProgressTrackerProps = {
  sectionType: string;
  daysLeft?: number;
  totalDays?: number | null;
  endDate?: string | null;
  completed?: boolean | null;
  maxMilage?: number;
  showEstimated: boolean;
  isLoading: boolean;
};

const ProgressTracker = ({
  daysLeft,
  totalDays = 0,
  completed = false,
  maxMilage,
  showEstimated,
  isLoading
}: ProgressTrackerProps) => {
  const daysLeftPercent = totalDays !== 0 && daysLeft && totalDays ? Math.min(daysLeft / totalDays, 1) : 0;

  return (
    <ProgressTrackerWrapper>
      <>
        { !completed && (
          <ProgressMeter
            showEstimated={showEstimated}
            daysLeft={daysLeft}
            totalDays={totalDays}
            daysLeftPercent={daysLeftPercent}
            maxMilage={maxMilage}
            isLoading={isLoading}
          />
        )}
      </>
    </ProgressTrackerWrapper>
  );
};

export default ProgressTracker;